import * as React from 'react';
import Alert, { AlertColor } from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { type } from 'os';
import { Collapse, IconButton } from '@mui/material';
import { Close, Done, DoneRounded, Error } from '@mui/icons-material';


export default function Message(props : {Message : string, type : AlertColor}) {
  const [view, setView] = React.useState(true);
    
  return (
    <>
        <Alert
          hidden = {view}
            variant="standard" 
            severity={props.type}
            icon={props.type != "success"? <Error />: <DoneRounded />}
            onClose={()=>{setView(false)}}
        >
        {props.Message}
    </Alert>
    <br />
    </>
  );
}